/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDto } from '../../models/user-dto';

export interface GetUserControllerFindAll$Params {

/**
 * 사용자 역할
 */
  role?: 'PARENT' | 'TEACHER' | 'ALL';

/**
 * 보호자 ID
 */
  guardianId?: string;

/**
 * 소속 센터
 */
  centerIds?: Array<string>;

/**
 * 상태
 */
  status?: Array<'ACTIVE' | 'WITHDRAWN' | 'BLOCKED'>;

/**
 * 생년월일
 */
  birthStartAt?: string;

/**
 * 생년월일
 */
  birthEndAt?: string;

/**
 * 가입일
 */
  startAt?: string;

/**
 * 가입일
 */
  endAt?: string;

/**
 * 검색어
 */
  query?: string;
}

export function getUserControllerFindAll(http: HttpClient, rootUrl: string, params?: GetUserControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
  const rb = new RequestBuilder(rootUrl, getUserControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('role', params.role, {});
    rb.query('guardianId', params.guardianId, {});
    rb.query('centerIds', params.centerIds, {});
    rb.query('status', params.status, {});
    rb.query('birthStartAt', params.birthStartAt, {});
    rb.query('birthEndAt', params.birthEndAt, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserDto>>;
    })
  );
}

getUserControllerFindAll.PATH = '/api/user';
